import config from '@config/index';
import { ModalRef } from '@app/shared/modules/modal';
import { waterwaysSelector, waterwaysActions } from '@app/core/store/waterways/waterways.slice';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Map, NavigationControl } from 'mapbox-gl';
import { FormControl, FormGroup } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { USStates, IsoCountryCode, relativePaths } from '@app/constants';
import _ from 'lodash';
import { Router } from '@angular/router';
import { Waterway } from '@app/core/features/waterways/waterway.models';
import { FetchWaterwaysPremiumPayload } from '@app/core/features/waterways/waterway.payload';

@Component({
  selector: 'app-premium-coverage-modal',
  templateUrl: './premium-coverage-modal.component.html',
  styleUrls: ['./premium-coverage-modal.component.scss'],
})
export class PremiumCoverageModalComponent implements OnInit,OnDestroy {
  map: Map;
  style = `${config.mapboxStylePrefix}${config.mapboxStyleUrl}`;
  removeOtherState = USStates.pop();
  regionDropdownList: any[] = USStates;
  waterwaysDropdownList: Waterway[];
  isRegionListFetching: Observable<boolean>;
  DEFAULT_MAP_ZOOM = config.defaultMapZoom;
  currentLocation: [number, number];
  form: FormGroup;
  regionControl: FormControl;
  waterwayControl: FormControl;
  filteredRegion: Observable<any[]>;
  filteredWaterways: Observable<Waterway[]>;
  isCloseState = true;
  isCloseWaterway = true;
  inputState = '';
  inputWaterway = '';
  relativePaths = relativePaths;

  waterwaysStateSubs: Subscription;

  constructor(
    private store: Store<{}>,
    private router: Router,
    public modalRef: ModalRef,
    private dialogRef: MatDialogRef<PremiumCoverageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PremiumCoverageModalComponent,
  ) {}

  ngOnInit(): void {
    this.regionControl = new FormControl();
    this.waterwayControl = new FormControl();
    this.filteredRegion = this.regionControl.valueChanges.pipe(
      startWith(''),
      map(value => this.onFilter(value)),
    );

    this.waterwaysStateSubs = this.store.select(waterwaysSelector.getWaterwayPremium).subscribe((waterway: any) => {
      this.waterwaysDropdownList = waterway;
      this.filteredWaterways = this.waterwayControl.valueChanges.pipe(
        startWith(''),
        map(value => this.onWaterwaysFilter(value)),
      );
    });
  }

  ngOnDestroy(): void {
    this.waterwaysStateSubs.unsubscribe();
  }

  onChange() {
    this.waterwayControl.setValue('');
  }

  onKeyupState(value) {
    this.isCloseState = _.isEmpty(value);
  }

  onKeyupWaterway(value) {
    this.isCloseWaterway = _.isEmpty(value);
    if (_.isEmpty(value) || value.length === 1 || value.length % 3 === 0) {
      const state = this.regionDropdownList.find(x => x.name.toLowerCase() === this.inputState.toLowerCase());
      const payload = new FetchWaterwaysPremiumPayload(state.acronym, IsoCountryCode, value);
      this.store.dispatch(waterwaysActions.getWaterwayPremium(payload));
    }
  }

  cleanState() {
    this.inputState = '';
    this.inputWaterway = '';
    this.isCloseState = true;
    this.isCloseWaterway = true;
  }

  cleanWaterway() {
    this.inputWaterway = '';
    this.isCloseWaterway = true;
  }

  onFilter(name: string) {
    return this.regionDropdownList.filter(state => state.name.toLowerCase().indexOf(name.toLowerCase()) >= 0);
  }

  onWaterwaysFilter(name: string) {
    return this.waterwaysDropdownList.filter(state => state.name.toLowerCase().indexOf(name.toLowerCase()) >= 0);
  }

  onRegionSelected(value) {
    this.onKeyupState(this.inputState);
    const state = this.regionDropdownList.find(x => x.name.toLowerCase() === value.toLowerCase());
    const payload = new FetchWaterwaysPremiumPayload(state.acronym);
    this.store.dispatch(waterwaysActions.getWaterwayPremium(payload));
  }

  mapLoad(evt: any) {
    this.map = evt;
    this.map.addControl(new NavigationControl());
    this.map.setCenter([this.map.getStyle().center[0], this.map.getStyle().center[1]]);
  }

  onWaterwaySelection(selectedWaterway: string) {
    this.onKeyupWaterway(this.inputWaterway);
    const waterway = this.waterwaysDropdownList.find(x => x.name.toLowerCase() === selectedWaterway.toLowerCase());
    this.currentLocation = [waterway.longitude, waterway.latitude];
    this.map.flyTo({
      center: [waterway.longitude, waterway.latitude],
      essential: true,
      zoom: 12,
      duration: 2000,
    });
  }

  handleCancel(): void {
    this.dialogRef.close();
  }

  navigatePremium(): void {
    this.dialogRef.close();
    this.dialogRef.afterClosed().subscribe(() => {
      this.router.navigate([relativePaths.SIGN_UP_PREMIUM]);
    });
  }
}
